import Card from '../../../components/card/Card';
import P from '../../../components/texts/p/P';
import Modal from '../../../components/modal/modal';
import TextArea from '../../../components/textarea/TextArea';
import { useState } from 'react';

interface CloseApplicationModalProps {
  isOpen: boolean;
  onClose: Function;
  onSecondaryAction: Function;
  onPrimaryAction: Function;
  loadingPrimaryBtn: boolean;
}

const CloseApplicationModal: React.FC<CloseApplicationModalProps> = ({
  isOpen,
  onClose,
  onSecondaryAction,
  onPrimaryAction: onPrimaryAction,
  loadingPrimaryBtn = false,
}) => {
  const [modalText, setModalText] = useState<string>('');

  const renderContent = () => {
    return (
      <Card>
        <P type='1' variant='neutral' withMargin={false}>
          Cerrar la carpeta impedirá seguir gestionando esta solicitud.
        </P>
        <P type='1' variant='danger' withMargin={false}>
          Esta acción no se puede deshacer
        </P>
        <Card margin={{ top: '3' }}>
          <TextArea
            placeHolder='Escribí el motivo del cierre (opcional)'
            maxLengthHelpText={false}
            onChange={(e) => setModalText(e.target.value)}
          ></TextArea>
        </Card>
      </Card>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={'Cerrar carpeta'}
      primaryText='Cerrar carpeta'
      primaryVariant='primary'
      secondaryVariant='secondary'
      onSecondaryAction={() => onSecondaryAction(modalText)}
      onPrimaryAction={() => onPrimaryAction(modalText)}
      children={renderContent()}
      loadingPrimaryBtn={loadingPrimaryBtn}
    />
  );
};

export default CloseApplicationModal;
